import { Row, Col, Typography, Button } from "antd";
import {
  PlayCircleOutlined,
  SolutionOutlined,
  ReadOutlined,
} from "@ant-design/icons";
import { F4, F2, F5 } from "../../../assets";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { LanguageContext } from "../../../context/Language.contex";
import { useContext } from "react";

const { Title, Text } = Typography;

const Section2 = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const { language } = useContext(LanguageContext);

  return (
    <div
      style={{
        position: "relative", // penting untuk posisi absolut elemen child
        padding: "20vh 40px",
        // minHeight: "100vh",
        background: "linear-gradient(to right, #f8f9fc, #ffffff)",
        overflow: "hidden", // mencegah blur overflow ke luar
      }}
    >
      {/* Blur Ornamen di bawah kiri */}
      <div
        style={{
          position: "absolute",
          top: 180,
          right: -90,
          width: 300,
          height: 300,
          background: "rgba(0, 166, 225, 0.29)",
          filter: "blur(120px)",
          zIndex: 0,
        }}
      />

      <Row
        gutter={32}
        align="middle"
        justify="center"
        style={{ position: "relative", zIndex: 1 }}
      >
        {/* Kiri - Gambar */}
        <Col xs={24} md={12}>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <img
                src={F2}
                alt="Person 1"
                style={{
                  width: "100%",
                  height: "180px",
                  borderRadius: "12px",
                  objectFit: "cover",
                }}
              />
            </Col>
            <Col span={12}>
              <img
                src={F4}
                alt="Person 2"
                style={{
                  width: "100%",
                  height: "180px",
                  borderRadius: "12px",
                  objectFit: "cover",
                }}
              />
            </Col>
            <Col span={24}>
              <img
                src={F5}
                alt="Person 3"
                style={{
                  width: "100%",
                  height: "250px",
                  borderRadius: "12px",
                  objectFit: "cover",
                }}
              />
            </Col>
          </Row>
        </Col>

        {/* Kanan - Text dan Button */}
        <Col xs={24} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              paddingLeft: 32,
            }}
          >
            <Text
              style={{
                color: "#2C74B3",
                fontWeight: "bold",
                textTransform: "uppercase",
              }}
            >
              {language[6]}
            </Text>
            <Title
              level={2}
              style={{ marginTop: 10, fontSize: "2rem", textAlign: "left" }}
            >
              {language[4]}, <br /> {language[5]}
            </Title>
            <Text
              style={{ marginTop: 20, fontSize: "16px", textAlign: "left" }}
            >
              {language[3]}
            </Text>

            {/* Tombol tambahan */}
            <div
              style={{
                display: "flex",
                gap: "16px",
                marginTop: 24,
                flexWrap: "wrap",
              }}
            >
              <Button
                type="default"
                icon={<SolutionOutlined />}
                size="large"
                onClick={() => {
                  navigate(`/career`);
                }}
                style={{
                  border: "1px solid #2C74B3",
                  color: "#2C74B3",
                  transition: "all 0.3s",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#2C74B3";
                  e.currentTarget.style.color = "white";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "white";
                  e.currentTarget.style.color = "#2C74B3";
                }}
              >
                {language[7]}
              </Button>
              <Button
                type="default"
                icon={<ReadOutlined />}
                onClick={() => {
                  navigate(`/career/intership`);
                }}
                size="large"
                style={{
                  border: "1px solid #2C74B3",
                  color: "#2C74B3",
                  transition: "all 0.3s",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#2C74B3";
                  e.currentTarget.style.color = "white";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "white";
                  e.currentTarget.style.color = "#2C74B3";
                }}
              >
                {language[8]}
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Section2;
